import styled from 'styled-components';

export const Form = styled.form`
  width: 92%;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  flex-direction: column;

  margin-bottom: 0;

  > label {
    font-size: 14px;
    display: flex;
    gap: 4px;
  }

  span {
    font-size: 12px;
  }

  @media(max-width: 639px){
    width: 85%;

    > label {
      font-size: 13px;
    }
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    > label {
      font-size: 16px;
    }
  }
`;

export const InputForm = styled.input<{ hasError: boolean }>`
  width: 100%;

  padding: 8px;

  border: 0;
  border-bottom: ${props => props.hasError ? `2px solid ${props.theme?.palette?.error?.red || '#FF3838'}` : `1px solid ${props.theme?.palette?.greyscale?.grey200 || '#b6b6b6'}`};

  margin: 12px 0 18px;

  background: transparent;

  font-size: 14px;

  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-bottom-color: ${props => props.hasError ? (props.theme?.palette?.error?.red || '#FF3838') : (props.theme?.palette?.primary?.blue500 || 'hsl(217 100% 72%)')};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media(min-width: ${({ theme }) => theme?.breakpoints?.desktopXl || '80rem'}){
    margin-bottom: 28px;
    font-size: 15px;
  }
`;

export const Button = styled.button`
  width: 100%;

  padding: 9px 24px;

  background: ${props => props.theme?.palette?.primary?.blue500 || 'hsl(217 100% 72%)'};

  border: 0;

  font-size: 14px;
  font-weight: 600;
  color: #FFF;

  cursor: pointer;

  transition: background-color 0.3s ease;

  &:hover:not(:disabled) {
    background-color: ${props => props.theme?.palette?.primary?.blue600 || 'rgb(100, 151, 232)'};
  }

  &:disabled {
    background-color: ${props => props.theme?.palette?.greyscale?.grey200 || '#b6b6b6'};
    cursor: not-allowed;
    opacity: 0.7;
  }

  @media(max-width: 639px){
    padding: 10px 24px;
    font-size: 12px;
  }

  @media(min-width: ${({ theme }) => theme?.breakpoints?.desktopXl || '80rem'}){
    padding: 10px 24px;
    font-size: 15px;
  }
`;

export const ErrorText = styled.p`
  color: ${props => props.theme?.palette?.error?.red || '#FF3838'};
  font-size: 12px;
  margin: 0;
  line-height: 1.4;
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px;
  background-color: hsl(0 100% 97%);
  border: 1px solid hsl(0 100% 80%);
  border-radius: 4px;
  margin-bottom: 12px;

  @media(max-width: 639px){
    padding: 10px 12px;
    gap: 6px;
  }
`;

export const AlternativeText = styled.p`
  color: ${props => props.theme?.palette?.secondary?.orange500 || 'hsl(17 71% 54%)'};
  font-size: 12px;
  margin: 0;
  padding: 0;
  line-height: 1.3;
  font-weight: 500;
`;

export const SocialButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-bottom: 16px;

  @media(max-width: 639px){
    gap: 10px;
    margin-bottom: 14px;
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    gap: 14px;
    margin-bottom: 18px;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  margin: 16px 0;
  color: ${props => props.theme.palette.greyscale.grey500};
  font-size: 12px;
  font-weight: 500;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${props => props.theme.palette.greyscale.grey200};
  }

  @media(max-width: 639px){
    margin: 14px 0;
    font-size: 11px;
  }

  @media(min-width: ${({ theme }) => theme.breakpoints.desktopXl}){
    margin: 18px 0;
    font-size: 13px;
  }
`;